import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/index.jsx';
import { useAuth } from '../auth.jsx';

// "Upgrade to sell" — shown wherever a Silver member tries to list a
// product (and when the daily inquiry limit is reached). A company's user
// sees the company's plan; the plans link only with "billing" rights.
export default function UpgradeCard({ reason = 'sell' }) {
  const { t } = useI18n();
  const { user } = useAuth() || {};
  const member = !!user?.team && !user.team.isOwner;
  const key = member && reason === 'sell' ? 'sellTeam' : reason;
  const billing = !member || !!user.team.perms?.['billing.view'];
  return (
    <div className="upgrade-card">
      <div className="upgrade-card-badge" aria-hidden="true">★</div>
      <div>
        <h2>{t(`upgrade.${key}Title`)}</h2>
        <p>{t(`upgrade.${key}Text`)}</p>
      </div>
      {billing && !user?.team?.pme && <Link className="btn btn-primary" to="/account/plan">{t('upgrade.cta')}</Link>}
    </div>
  );
}

// A company user whose role can't add products (before the plan message).
export function NoPermissionCard() {
  const { t } = useI18n();
  return (
    <div className="upgrade-card">
      <div className="upgrade-card-badge" aria-hidden="true">!</div>
      <div>
        <h2>{t('upgrade.noAddTitle')}</h2>
        <p>{t('errors.team_cannot_add_products')}</p>
      </div>
    </div>
  );
}
